import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Field } from '@itds/elements/index.js';
import { Vive_Term_Life, Vive_Return_of_Premium } from '@itds/Constants';

const LimitProductTypes = ({ vive_quoter, handleSave }) => {
  const all_product_types = [...Vive_Term_Life, ...Vive_Return_of_Premium];

  const [data, setData] = useState({
    product_types: vive_quoter?.product_types?.length
      ? vive_quoter?.product_types
      : all_product_types
  });

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const save = () => {
    handleSave(data);
  };

  const selectAll = () => {
    if (data?.product_types?.length === all_product_types.length) {
      setData({
        ...data,
        product_types: []
      });
    } else {
      setData({
        ...data,
        product_types: all_product_types
      });
    }
  };

  return (
    <>
      <div style={{ display: 'flex', marginBottom: 30 }}>
        <Button inline={true} onClick={selectAll} small={true}>
          {data?.product_types?.length === all_product_types?.length
            ? 'Unselect All'
            : 'Select All'}
        </Button>
      </div>

      <div style={{ display: 'flex', marginBottom: 30 }}>
        <div style={{ width: '25%' }}>
          <Field label='Term Life'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={Vive_Term_Life.map(p => ({ value: p }))}
              selected={data?.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Return of Premium'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={Vive_Return_of_Premium.map(p => ({ value: p }))}
              selected={data?.product_types || []}
            />
          </Field>
        </div>
      </div>

      <Button disabled={!data?.product_types?.length} inline={true} onClick={save}>
        Save Changes
      </Button>
    </>
  );
};

LimitProductTypes.propTypes = {
  handleSave: PropTypes.func,
  vive_quoter: PropTypes.object
};

export default LimitProductTypes;
